import userModule from '@/framework/security/userModule'
import routeModule from '@/router/routeModule'

import checkInModule from '@/views/check/in/checkInModule'

export default {
  preinstall (Vue) {
    // these modules need to be loaded first
    Vue.use(routeModule)
    Vue.use(userModule)
  },
  install (Vue) {
    Vue.use(checkInModule)
  }
}
